import React from 'react';
import { TextField, MenuItem, Grid } from '@mui/material';

const ProfessionalInformation = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Current Job Title"
          name="currentJobTitle"
          value={formData.currentJobTitle || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Current Employer"
          name="currentEmployer"
          value={formData.currentEmployer || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Total Work Experience (Years)"
          name="totalWorkExperienceYears"
          value={formData.totalWorkExperienceYears || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Total Work Experience (Months)"
          name="totalWorkExperienceMonths"
          value={formData.totalWorkExperienceMonths || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Key Skills"
          name="keySkills"
          value={formData.keySkills || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Accounting">Accounting</MenuItem>
          <MenuItem value="Auditing">Auditing</MenuItem>
          <MenuItem value="Investment Banking">Investment Banking</MenuItem>
          <MenuItem value="Taxation">Taxation</MenuItem>
          <MenuItem value="Risk Management">Risk Management</MenuItem>
          <MenuItem value="Financial Planning">Financial Planning</MenuItem>
          <MenuItem value="Treasury">Treasury</MenuItem>
          <MenuItem value="Compliance">Compliance</MenuItem>
          <MenuItem value="Corporate Finance">Corporate Finance</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Current Salary (CTC in INR)"
          name="currentSalary"
          value={formData.currentSalary || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Expected Salary (CTC in INR)"
          name="expectedSalary"
          value={formData.expectedSalary || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Employment Type Preference"
          name="employmentTypePreference"
          value={formData.employmentTypePreference || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Full-time">Full-time</MenuItem>
          <MenuItem value="Part-time">Part-time</MenuItem>
          <MenuItem value="Freelance">Freelance</MenuItem>
          <MenuItem value="Contract">Contract</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default ProfessionalInformation;